import {
  GeckoComponentModel,
  GeckoConeCourse,
  GeckoLegacyBoilerWall,
  GeckoLegacyBoilerWalls,
  GeckoLegacyCone,
  GeckoShellCourse,
  GeckoVerticalTankShell,
} from 'types'

type SectionType<T extends GeckoComponentModel | undefined> =
  T extends GeckoVerticalTankShell
    ? GeckoShellCourse[]
    : T extends GeckoLegacyCone
      ? GeckoConeCourse[]
      : T extends GeckoLegacyBoilerWalls
        ? GeckoLegacyBoilerWall[]
        : undefined

export function getSectionsFromComponentModel<
  T extends GeckoComponentModel | undefined,
>(componentModel: T | undefined): SectionType<T> {
  if (componentModel instanceof GeckoVerticalTankShell) {
    return componentModel.coursesArray as SectionType<T>
  } else if (componentModel instanceof GeckoLegacyCone) {
    return componentModel.coursesArray as SectionType<T>
  } else if (componentModel instanceof GeckoLegacyBoilerWalls) {
    return componentModel.wallsArray as SectionType<T>
  }
  return undefined as SectionType<T>
}
